import { DayTypeType } from './day.interface';
import { Festival } from './festival.interface';

export interface TableCard {
  id: number;
  uuid: string;
  festival_id: number;
  date: string;
  daytype: DayTypeType;
  filename: string;
  updated_at: string;
  created_at: string;
  festival?: Festival;
}

export interface TableCardParams {
  festival_id: number;
  date: string;
  daytype: DayTypeType;
  table_id?: number;
}
